<template>
<div class="chapter">
<div class="inner_page">
<p class="p-p2">murder run</p>
<p class="p-p2">Shelly Frome</p>
<p class="whitespace"> </p>
<p class="whitespace"> </p>
<p class="p-p3"><img alt="" class="calibre1" src="Images/logo.jpg"/></p>
<p class="p-p3">Mechanicsburg, Pennsylvania USA</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?2dfbb743